// File: src/menuData.master.js
export const masterMenus = [
  {
    id: "org",
    label: "MASTER PANEL",
    icon: "users",
    items: [
      {
        label: "USERS",
        icon: "list",
        to: "/app/master/users",
      },
      { label: "SUPERADMIN", icon: "list", to: "/app/master/superadmins" },
      { label: "ROLES & PERMISSION", icon: "list", to: "/app/master/roles" },
      {
        label: "SUBSCRIPTION PLANS",
        icon: "list",
        to: "/app/master/subscription-plans",
      },
      {
        label: "GROUPS",
        icon: "list",
        to: "/app/master/groups",
      },
      { label: "PINCODES", icon: "list", to: "/app/master/location-pins" },
      {
        label: "CUSTOMERS",
        icon: "list",
        to: "/app/edit-team-role-position",
      },
      {
        label: "ACCOUNTS",
        icon: "list",
        to: "/app/edit-team-role-position",
      },
      {
        label: "UNITS",
        icon: "list",
        to: "/app/edit-team-role-position",
      },
      {
        label: "ACTIVITY LOGS",
        icon: "list",
        to: "/app/master/activity-logs",
      },
    ],
  },
  {
    id: "ops",
    label: "OPERATIONS",
    icon: "truck",
    items: [
      { label: "LEDGER", icon: "list", to: "/app/assign-pincode" },
      { label: "RECEIPTS", icon: "list", to: "/app/assign-pincode" },
      { label: "PAYMENTS", icon: "list", to: "/app/assign-pincode" },
      { label: "PARTNERS", icon: "list", to: "/app/assign-pincode" },
    ],
  },
];
